export function useRouteMetaChild() {
  const routeMetaChildTitle = ref("");

  function updateTitle(title: string) {
    routeMetaChildTitle.value = title;
  }

  provide("routeMetaChildTitle", {
    routeMetaChildTitle,
    updateTitle,
  });
}
